<ds-modal [modal]="modal" [title]="'menu' | translate" [colorVariant]="DsModalColorVariant.DarkBlue">
  <ul>
    @for (menuItem of topLevelMenuItems$ | async; track menuItem.id) {
      @if (menuItem.isAvailable) {
        <li
          [class.separator-bottom]="menuItem.id === NavigationItem.workspace"
          [class.separator-top]="menuItem.id === NavigationItem.help || menuItem.id === NavigationItem.old_help"
        >
          @if (menuItem.id === 'academy') {
            @if (academyNavigationItem$ | async; as academy) {
              @if (academy.isAvailable) {
                <button
                  ds-button
                  [variant]="DsButtonVariants.microActionHorizontalLayout"
                  [color]="DsButtonColor.White"
                  [microActionIcon]="academy.iconName"
                  role="link"
                  class="academy-btn"
                  (click)="academy.onClick()"
                  data-test-id="academy-link"
                >
                  {{ 'academy' | translate }}
                </button>
              }
            }
          } @else {
            @if (hasAvailableChildren(menuItem)) {
              <button
                ds-button
                [variant]="DsButtonVariants.microActionWithChevronRight"
                [color]="DsButtonColor.White"
                [microActionIcon]="menuItem.iconName"
                [attr.data-test-id]="menuItem.id + '-button'"
                (click)="openSecondLevelModal(menuItem)"
              >
                {{ menuItem.label | translate }}
              </button>
            } @else {
              <a
                ds-button
                [variant]="DsButtonVariants.microActionHorizontalLayout"
                [color]="DsButtonColor.White"
                [microActionIcon]="menuItem.iconName"
                [routerLink]="menuItem.routerLink"
                [attr.data-test-id]="menuItem.id + '-link'"
                (click)="onModalClose()"
              >
                {{ menuItem.label | translate }}
                @if (menuItem.id === NavigationItem.notifications) {
                  <span class="ds-visually-hidden">&nbsp;</span>
                  <span class="notifications-badge" data-test-id="notifications-badge">{{ notificationNumber$ | async }}</span>
                  <span class="ds-visually-hidden">&nbsp;{{ 'unread' | translate }}</span>
                }
              </a>
            }
          }
        </li>
      }
    }
  </ul>
</ds-modal>
